import { Capacitor } from "@capacitor/core";

/** True when running on the app subdomain (app.gomash.ai / app.localhost) or native */
export function isAppDomain(): boolean {
  if (Capacitor.isNativePlatform()) return true;
  return window.location.hostname.startsWith("app.");
}

/** Full URL for the app subdomain — reads from VITE_APP_URL */
export function getAppUrl(): string {
  if (import.meta.env.DEV)
    return import.meta.env.VITE_APP_URL || "http://app.localhost:5173";
  return import.meta.env.VITE_APP_URL || "https://app.gomash.ai";
}

/** Full URL for the landing/marketing domain */
export function getLandingUrl(): string {
  // Explicit landing URL takes priority
  if (import.meta.env.VITE_LANDING_URL) return import.meta.env.VITE_LANDING_URL;
  if (import.meta.env.DEV) return "http://localhost:5173";
  // app.gomash.ai → https://www.gomash.ai
  const appUrl = import.meta.env.VITE_APP_URL || "https://app.gomash.ai";
  const url = new URL(appUrl);
  const host = url.hostname.replace(/^app\./, "www.");
  return `${url.protocol}//${host}`;
}

/**
 * Set a cross-subdomain cookie hint that the user is logged in.
 * Readable by the landing domain (www.gomash.ai) to redirect to app.gomash.ai.
 */
export function setLoggedInHint(loggedIn: boolean): void {
  const hostname = window.location.hostname;
  // Extract root domain (e.g., "gomash.ai" from "app.gomash.ai")
  const parts = hostname.split(".");
  const rootDomain = parts.length >= 2 ? parts.slice(-2).join(".") : hostname;

  if (loggedIn) {
    document.cookie = `mash_logged_in=1; domain=.${rootDomain}; path=/; max-age=31536000; SameSite=Lax; Secure`;
  } else {
    document.cookie = `mash_logged_in=; domain=.${rootDomain}; path=/; max-age=0; SameSite=Lax; Secure`;
  }
}

/** Check if the cross-subdomain logged-in hint cookie exists */
export function hasLoggedInHint(): boolean {
  return document.cookie
    .split(";")
    .some(c => c.trim().startsWith("mash_logged_in=1"));
}
